/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class MainDrawingService {
        constructor(private $http: ng.IHttpService, private baseService: BaseService) { }

        public getMainDrawings(filter: ModelFilterViewModel, isLandscape: boolean, pageNumber: number) {
            return this.baseService.post('maindrawing/{companyNumber}/filter?isLandscape=' + isLandscape + '&pageNumber=' + pageNumber, filter).then(j => { return j.data });
        }

        public search(filter: ModelFilterViewModel, isLandscape: boolean) {
            return this.baseService.post('maindrawing/{companyNumber}/search?isLandscape=' + isLandscape, filter).then(j => { return j.data });
        }

        public scroll(scrollId: string, isLandscape: boolean) {
            return this.baseService.get('maindrawing/{companyNumber}/scroll?scrollId=' + scrollId + '&isLandscape=' + isLandscape).then(j => { return j.data });
        }

        public uploadImages(associationNumber: string, departmentNumber: string, localizer: string, data: FormData) {
            return this.baseService.upload('maindrawing/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/' + localizer + '/upload', data, null).then(j => { return j.data });
        }

        public delete(associationNumber: string, departmentNumber: string, localizer: string, fileName: string) {
            return this.baseService.delete('maindrawing/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/' + localizer + '/' + fileName + '/delete').then(j => { return j.data });
        }

        public getArchive(associationNumber: string, departmentNumber: string, localizer: string) {
            return this.baseService.getArrayBuffer('maindrawing/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/' + localizer + '/zip').then(data => data.data);
        }
    }

    MainDrawingService.$inject = ['$http', 'BaseService'];
    angular
        .module('eseebase')
        .service('MainDrawingService', MainDrawingService);
}